export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Importo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Risultato"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transazione"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiorna stato"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link utili"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In corso"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successo"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fallito"])}
}